import React from "react";
import ReactDOM from "react-dom";
import BrandsPopup from "./containers/BrandsPopup";
import {isEmpty} from "lodash";

export const initBrandsPopup = className => {
  let elements = document.querySelectorAll(`.${className}`);
  if (!isEmpty(elements)) {
    for (let element of elements) {
      ReactDOM.render(<BrandsPopup brandIds={JSON.parse(element.getAttribute('data-ids'))}/>, element);
    }
  }
};
